import { useEffect, useRef } from 'react';
import { useAppSelector } from './reduxHooks';
import { ConfigProvider } from 'antd';
import { themeObject } from '@app/styles/themes/themeVariables';
import { hexToRGB } from '@app/utils/utils';

export const useThemeWatcher = (): void => {
  const theme = useAppSelector((state) => state.theme.theme);
  const customPrimary = useAppSelector((state) => state.theme.customPrimary);
  const root = useRef(document.querySelector(':root'));

  useEffect(() => {
    const html = root.current as HTMLElement | null;
    if (html) {
      html.setAttribute('data-no-transition', '');
      html.setAttribute('data-theme', theme);
      // remove transition after layout update
      requestAnimationFrame(() => {
        html.removeAttribute('data-no-transition');
      });
    }

    // Màu chủ đạo hiệu lực = màu user chọn (nếu có) hoặc mặc định theo theme
    const primary = customPrimary || themeObject[theme].primary;

    // Ghi đè CSS vars cho phần styled-components + Tailwind (var(--primary-color)).
    // Khi user xoá lựa chọn → gỡ override, trả về giá trị từ GlobalStyle.
    if (html) {
      if (customPrimary) {
        html.style.setProperty('--primary-color', primary);
        html.style.setProperty('--primary-rgb-color', hexToRGB(primary));
        html.style.setProperty('--info-rgb-color', hexToRGB(primary));
      } else {
        html.style.removeProperty('--primary-color');
        html.style.removeProperty('--primary-rgb-color');
        html.style.removeProperty('--info-rgb-color');
      }
    }

    // Re-tint toàn bộ component Ant Design (v4 CSS-variable theme)
    ConfigProvider.config({
      theme: {
        primaryColor: primary,
        infoColor: primary,
        successColor: themeObject[theme].success,
        errorColor: themeObject[theme].error,
        warningColor: themeObject[theme].warning,
      },
    });
  }, [theme, customPrimary]);
};
